import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export function buildLoginForm(fb: FormBuilder): FormGroup {
  return fb.group({
    username: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(4)]],
    remember: [false],
  });
}